/**
 * @generated SignedSource<<4cc38a0d6399d29965ebdb92a59dfe8e>>
 * @relayHash cf8d9ae636baa188388f74c45310f51f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c516dca6df134076002275d6915c21a55c3d09a90d07f00461567ee840ad98ae

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSchemeAssociatedFieldsInput = {
  nameOrDescriptionFilter?: string | null | undefined;
  schemeId: string;
};
export type FieldSchemePageQuery$variables = {
  cloudId: string;
  fieldSchemeAri: string;
  input: JiraFieldSchemeAssociatedFieldsInput;
  isPerSchemeFieldLimitEnabled: boolean;
  schemeId: string;
};
export type FieldSchemePageQuery$data = {
  readonly fieldSchemeNode: {
    readonly name?: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PageHeaderGroup_scheme">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable" | "PageHeaderGroup_query">;
};
export type FieldSchemePageQuery = {
  response: FieldSchemePageQuery$data;
  variables: FieldSchemePageQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider": isFieldSchemeOperationsEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider": isEfaCmpBetaFieldsManagementFeaturesEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isEfaCmpBetaFieldsManagementFeaturesEnabled_provider from '@atlassian/jira-relay-provider/src/is-efa-cmp-beta-fields-management-features-enabled.relayprovider';
import isFieldSchemeOperationsEnabled_provider from '@atlassian/jira-relay-provider/src/is-efa-cmp-field-scheme-operations-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSchemeAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPerSchemeFieldLimitEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemeId"
},
v5 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v6 = {
  "kind": "Variable",
  "name": "schemeId",
  "variableName": "schemeId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "fieldSchemeAri"
  }
],
v8 = {
  "kind": "Variable",
  "name": "isPerSchemeFieldLimitEnabled",
  "variableName": "isPerSchemeFieldLimitEnabled"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v11 = [
  (v10/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v5/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "description"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AssociatedFieldsTable"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v7/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  (v8/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "PageHeaderGroup_scheme"
              },
              (v9/*: any*/)
            ],
            "type": "JiraFieldScheme"
          }
        ]
      },
      {
        "args": [
          (v10/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PageHeaderGroup_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemeAssociatedFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldSchemeAssociatedField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      (v9/*: any*/),
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "typeName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFieldLocked"
                  },
                  {
                    "concreteType": "JiraIssueFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldSchemeOperations",
                            "kind": "LinkedField",
                            "name": "fieldSchemeOperations",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canRemove"
                              }
                            ]
                          }
                        ]
                      },
                      (v12/*: any*/)
                    ]
                  },
                  (v14/*: any*/),
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldConfig",
                        "kind": "LinkedField",
                        "name": "fieldConfig",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              (v6/*: any*/)
                            ],
                            "concreteType": "JiraFieldWorkTypeDescriptionCustomization",
                            "kind": "LinkedField",
                            "name": "descriptionCustomisations",
                            "plural": true,
                            "selections": [
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isHighlighted"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      {
        "args": (v11/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemeAssociatedFields"
      },
      {
        "alias": "fieldSchemeNode",
        "args": (v7/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "schemeId"
              },
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectsCount"
              },
              {
                "condition": "isPerSchemeFieldLimitEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fieldsCount"
                  }
                ]
              }
            ],
            "type": "JiraFieldScheme"
          }
        ]
      },
      {
        "condition": "isPerSchemeFieldLimitEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v10/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "jira_fieldsPerSchemeLimit"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c516dca6df134076002275d6915c21a55c3d09a90d07f00461567ee840ad98ae",
    "metadata": {},
    "name": "FieldSchemePageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpfieldschemeoperationsenabledrelayprovider": isFieldSchemeOperationsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisefacmpbetafieldsmanagementfeaturesenabledrelayprovider": isEfaCmpBetaFieldsManagementFeaturesEnabled_provider
    }
  }
};
})();

(node as any).hash = "44c873ae7f3da76b88b35038c7c50f60";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
